import { createContext, useContext } from 'react';
import dayjs from 'dayjs';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { Feiertag } from '@/domain/termine/shared/types/Feiertag';

export interface CalendarContextProps {
  monthDate: { year: string; month: string };
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  standortId?: string;
  termine: Termin[];
  colIndex?: number;
  rowIndex?: number;
  feiertage?: Feiertag[];
}

export const CalendarContext = createContext<CalendarContextProps>({
  monthDate: { year: '', month: '' },
  startDate: dayjs(),
  endDate: dayjs(),
  standortId: '',
  termine: [],
  colIndex: 0,
  rowIndex: 0,
  feiertage: [],
});

export function useCalendarContext() {
  const ctx = useContext(CalendarContext);
  if (!ctx) {
    throw new Error(
      'useCalendarContext must be used within CalendarContext.Provider',
    );
  }
  return ctx;
}
